import React from 'react';

const FormContainer: React.FC<{}> = (props) => {
    return <div className="dlc-form2-container">{props.children}</div>;
};

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/controls/forms/common/FormContainer.tsx